import React from 'react';

import 'src/app/components/RegulationsContact.scss';


const RegulationsContact = () => (
  <p styleName="personal-data">
    Administratorem Twoich danych osobowych jest:
    Grupa Pracuj sp. z o.o. z siedzibą w Warszawie,
    ul. Prosta 68, 00-838 Warszawa;
    adres e-mail:
    {' '}
    <a styleName="personal-data__link"
       title="Biuro"
       target="_blank" rel="noreferrer noopener"
       href="mailto:biuro@pracuj.pl">
      biuro@pracuj.pl.
    </a>
    {' '}
    W razie pytań skontaktuj się z nami:
    {' '}
    <a styleName="personal-data__link"
       title="Pomoc"
       target="_blank" rel="noreferrer noopener"
       href="mailto:pomoc@pracuj.pl"
    >
      pomoc@pracuj.pl;
    </a>
    {' '}
    lub naszym Inspektorem Ochrony Danych:
    {' '}
    <a styleName="personal-data__link"
       title="Inspektor Ochrony Danych"
       target="_blank" rel="noreferrer noopener"
       href="mailto:iod@pracuj.pl"
    >
      iod@pracuj.pl.
    </a>
    {' '}
    <a styleName="personal-data__link"
       title="Dowiedz się więcej"
       target="_blank" rel="noreferrer noopener"
       href="https://grupapracuj.pl/przetwarzanie-danych-uzytkownikow/"
    >
      Dowiedz się więcej
    </a>
  </p>
);

export default RegulationsContact;
